/**
 * @generated SignedSource<<ab768595d54613e59a70091fc7e1b4ae>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import type { Fragment, ReaderFragment } from 'relay-runtime';
export type JiraProjectType = "BUSINESS" | "CUSTOMER_SERVICE" | "PRODUCT_DISCOVERY" | "SERVICE_DESK" | "SOFTWARE" | "%future added value";
import type { FragmentRefs } from "relay-runtime";
export type ProjectHeader_inner_project$data = {
  readonly avatar: {
    readonly large: string | null | undefined;
  } | null | undefined;
  readonly canEditProjectConfig: {
    readonly canPerform: boolean;
  } | null | undefined;
  readonly created?: AGG$DateTime | null | undefined;
  readonly key: string;
  readonly name: string;
  readonly projectId: string | null | undefined;
  readonly projectType: JiraProjectType;
  readonly " $fragmentSpreads": FragmentRefs<"ExtraComponentsFar" | "HorizontalNavProjectBreadcrumbs" | "NavigationInviteButton_project" | "NavigationTeamButton_project" | "ProjectAvatar">;
  readonly " $fragmentType": "ProjectHeader_inner_project";
};
export type ProjectHeader_inner_project$key = {
  readonly " $data"?: ProjectHeader_inner_project$data;
  readonly " $fragmentSpreads": FragmentRefs<"ProjectHeader_inner_project">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [
    {
      "kind": "RootArgument",
      "name": "__relay_internal__pv__atlassianjirarelayprovidersrcjirainvitebuttonrelayprovider"
    }
  ],
  "kind": "Fragment",
  "name": "ProjectHeader_inner_project",
  "selections": [
    {
      "kind": "FragmentSpread",
      "name": "ProjectAvatar"
    },
    {
      "kind": "FragmentSpread",
      "name": "NavigationTeamButton_project"
    },
    {
      "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcjirainvitebuttonrelayprovider",
      "kind": "Condition",
      "passingValue": true,
      "selections": [
        {
          "kind": "FragmentSpread",
          "name": "NavigationInviteButton_project"
        },
        {
          "kind": "ScalarField",
          "name": "created"
        }
      ]
    },
    {
      "kind": "ScalarField",
      "name": "name"
    },
    {
      "kind": "RequiredField",
      "field": {
        "kind": "ScalarField",
        "name": "key"
      },
      "action": "THROW",
      "path": "key"
    },
    {
      "kind": "RequiredField",
      "field": {
        "kind": "ScalarField",
        "name": "projectType"
      },
      "action": "THROW",
      "path": "projectType"
    },
    {
      "kind": "ScalarField",
      "name": "projectId"
    },
    {
      "concreteType": "JiraAvatar",
      "kind": "LinkedField",
      "name": "avatar",
      "plural": false,
      "selections": [
        {
          "kind": "ScalarField",
          "name": "large"
        }
      ]
    },
    {
      "alias": "canEditProjectConfig",
      "args": [
        {
          "kind": "Literal",
          "name": "type",
          "value": "EDIT_PROJECT_CONFIG"
        }
      ],
      "concreteType": "JiraProjectAction",
      "kind": "LinkedField",
      "name": "action",
      "plural": false,
      "selections": [
        {
          "kind": "ScalarField",
          "name": "canPerform"
        }
      ],
      "storageKey": "action(type:\"EDIT_PROJECT_CONFIG\")"
    },
    {
      "kind": "FragmentSpread",
      "name": "ExtraComponentsFar"
    },
    {
      "kind": "FragmentSpread",
      "name": "HorizontalNavProjectBreadcrumbs"
    }
  ],
  "type": "JiraProject"
};

(node as any).hash = "5449c8927cb3183af5536b8b7c7526b0";

export default node;
